enum CalloutStatuses {
    dispatchedToTeam = 1,
    teamAcknowledged = 2,
    enRouteToDestination = 3,
    teamOnSite = 4,
    teamDeparted = 5
}

export default CalloutStatuses;